module.exports = __webpack_public_path__ + "static/media/help4.41a9caa4.png";